// extracted by mini-css-extract-plugin
export default {"Header":"Header__NX7OU","back":"back__GLfMq"};